// External store links for the MyAdventure-Passport mobile app.
// iOS is intentionally not exported — the App Store submission is pending, so
// every iOS surface should render a disabled "Coming Soon" affordance until we
// have a live link.
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.myadventure.myapp";
